export function bar(ctx) {
    return {
        styles: {
            main:      { ...ctx.pretty, radius: 999 },
            indicator: { radius: 999, bg_color: ctx.indic },
        },
    };
}
